<template>
<div class="content-wrapper">
    <div class="columns">
      <div class="column">
        <margin-title class="margin-title" :title="this.$t('signup.titleTxt')" subtitle="What are you looking to do?" />
      </div>
    </div>
    <div class="columns">
      <div class="column" v-for="item in types" :key="item.index">
        <SignupTypeCard :sel-type="item.type" :icon="item.icon" :title="item.title" :subtitle="item.subtitle" :desc="item.desc" v-on:select-type="selectType" />
      </div>
  </div>
</div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex'
import SignupTypeCard from '@/components/signup/signup-type-card'
import MarginTitle from '@/components/margin-title'
import JobseekerIcon from '@/assets/signup/signup-jobseeker.svg'
import ReferrerIcon from '@/assets/signup/signup-referrer.svg'
import HirerIcon from '@/assets/signup/signup-hirer.svg'

export default {
  components: {
    SignupTypeCard,
    MarginTitle
  },
  data () {
    return {
      types: [{
        type: 'jobseeker',
        title: 'Get hired and refer',
        subtitle: 'Signup as a Jobseeker',
        desc: 'Jobseekers can apply to jobs and refer people to jobs to earn a VIBES reward if successful.',
        icon: JobseekerIcon
      }, {
        type: 'referrer',
        title: 'Refer people for jobs',
        subtitle: 'Signup as a Referrer',
        desc: 'Referrers can browse jobs and jobseekers and earn a VIBES reward if their referral is hired successfully.',
        icon: ReferrerIcon
      }, {
        type: 'hirer',
        title: 'Hire people',
        subtitle: 'Signup as a Hirer',
        desc: 'Hirers can manage the full cycle of the hiring process with the help of the HireVibes team.',
        icon: HirerIcon
      }],
      showPanel: false
    }
  },
  methods: {
    ...mapMutations('signupForm', [
      'setProfile'
    ]),
    ...mapActions('users', [
      'updateUser'
    ]),
    async selectType (type) {
      this.setProfile(type)
      await this.updateUser({profile: type})
      if (type === 'jobseeker' || type === 'referrer') {
        this.$router.push('/signup/jobseeker/1')
      } else if (type === 'hirer') {
        this.$router.push('/signup/hirer')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~@/styles/defaults.scss';

  .columns {
    margin-bottom: 40px;
  }
  @media screen and (max-width: $tablet) {
  .columns {
    margin-bottom: 10px;
  }
  }
</style>



// WEBPACK FOOTER //
// src/pages/signup-type.vue